import {KeyControlSetting} from '@/components/deploymentAutocomplete/types';
import {CSSHexColorString} from '@/types';

export default class TypeUtil {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static isKeyControlSetting(object: any): object is KeyControlSetting {
        return typeof object === 'object'
            && Object.keys(object).length === 5
            && 'key' in object
            && 'altKey' in object
            && 'ctrlKey' in object
            && 'shiftKey' in object
            && 'metaKey' in object
            && typeof object.key === 'string'
            && typeof object.altKey === 'boolean'
            && typeof object.ctrlKey === 'boolean'
            && typeof object.shiftKey === 'boolean'
            && typeof object.metaKey === 'boolean';
    }

    public static isValidCSSHexColorString(input: unknown): input is CSSHexColorString {
        return typeof input === 'string' && (input.length === 4 || input.length === 7) && /^#[\da-f]+$/i.test(input);
    }
}
